import React from 'react';
import AuthForm from '../AuthForm';

const LoginModal = ({ onClose }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-60 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden relative animate-fade-in-up">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    ✕
                </button>

                <div className="p-8">
                    <div className="text-center mb-6">
                        <img src="/logo.png" alt="Clackbase" className="mx-auto h-12 w-12 mb-2" />
                        <h2 className="text-2xl font-bold text-gray-900">Join Clackbase</h2>
                        <p className="text-gray-600 mt-2">Log in to join games, chat, and host your own sessions.</p>
                    </div>

                    <AuthForm />

                    <div className="mt-6 text-center">
                        <button
                            onClick={onClose}
                            className="text-sm text-gray-500 hover:text-gray-700 underline"
                        >
                            Continue browsing as guest
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginModal;
